import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../CTAButton';
export function HeroSection() {
  return <section className="relative bg-ancestral-green text-ancestral-cream pt-20 md:pt-24 pb-12 md:pb-16 overflow-hidden" data-id="element-254">
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-ancestral-gold via-transparent to-transparent" data-id="element-255"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-256">
        <div className="max-w-4xl mx-auto text-center" data-id="element-257">
          <FadeIn delay={0.1} data-id="element-258">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ancestral-gold leading-tight mb-4 drop-shadow-sm" data-id="element-259">
              Transforma Tu Salud en 30 Días Con 300 Remedios Naturales Que Tu
              Abuela Conocía de Memoria
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-260">
            <p className="text-base md:text-lg text-ancestral-cream/90 leading-relaxed mb-6 max-w-2xl mx-auto font-light" data-id="element-261">
              El sistema de remedios ancestrales para recuperar tu energía,
              estabilizar tu presión y azúcar — con ingredientes de tu cocina.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="mb-8" data-id="element-262">
            <div className="relative w-full max-w-3xl mx-auto" data-id="element-263">
              <div className="absolute inset-0 bg-ancestral-gold/15 blur-3xl rounded-full transform -translate-y-4" data-id="element-264"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qHyFikBgUFTGMAxSBM6SVX/Mockup_1.png" alt="El Gran Recetario Ancestral - 300 Remedios Naturales Para Tu Salud" className="relative z-10 w-full rounded-2xl shadow-2xl border border-ancestral-gold/20" data-id="element-265" />
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-266">
            <CTAButton text="Quiero Mi Recetario Ancestral Ahora →" subtext="" data-id="element-267" />
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-268">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mt-5" data-id="element-269">
              {/* Compra 100% Segura */}
              <div className="flex items-center gap-2 text-ancestral-cream/80" data-id="element-270">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-ancestral-gold flex-shrink-0" data-id="element-271">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-272" />
                  <path d="M7 11V7a5 5 0 0110 0v4" data-id="element-273" />
                  <circle cx="12" cy="16" r="1" data-id="element-274" />
                </svg>
                <span className="text-xs md:text-sm font-medium" data-id="element-275">
                  Compra 100% Segura
                </span>
              </div>

              {/* Garantía de 60 Días */}
              <div className="flex items-center gap-2 text-ancestral-cream/80" data-id="element-276">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-ancestral-gold flex-shrink-0" data-id="element-277">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-278" />
                  <path d="M9 12l2 2 4-4" data-id="element-279" />
                </svg>
                <span className="text-xs md:text-sm font-medium" data-id="element-280">
                  Garantía de 60 Días
                </span>
              </div>

              {/* Acceso Inmediato vía E-mail */}
              <div className="flex items-center gap-2 text-ancestral-cream/80" data-id="element-281">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-ancestral-gold flex-shrink-0" data-id="element-282">
                  <rect x="2" y="4" width="20" height="16" rx="2" data-id="element-283" />
                  <path d="M22 7l-10 6L2 7" data-id="element-284" />
                </svg>
                <span className="text-xs md:text-sm font-medium" data-id="element-285">
                  Acceso Inmediato vía E-mail
                </span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}